import { formatSalesOrderNumber } from '@order-management/format';
import { SalesOrdersTableRow } from '@order-management/types';
import { formatDateToLocaleString } from '../../shared/utils';
import Link from '../../ui/link/link';
import { Column } from '../../ui/table/types';

const resolveSalesOrderSummaryColumns = (
  openLinksInNewTab?: boolean
): Column<SalesOrdersTableRow>[] => {
  return [
    {
      key: 'number',
      className: 'is-width-10',
      render: (el) => (
        <Link to={`/sales-orders/${el.id}`} openNewTab={openLinksInNewTab}>
          {formatSalesOrderNumber(el.number)}
        </Link>
      ),
      title: 'Sales Order',
      sortable: true,
    },
    {
      key: 'opportunity.account.name',
      className: 'is-width-20',
      render: (el) => (
        <Link
          to={`/accounts/${el.opportunity?.account?.id}`}
          openNewTab={openLinksInNewTab}
        >
          {el.opportunity?.account?.name}
        </Link>
      ),
      title: 'Account',
      sortable: true,
    },
    {
      key: 'opportunity.name',
      className: 'is-width-20',
      render: (el) => el.opportunity?.name,
      title: 'Opportunity Name',
      sortable: true,
    },
    {
      key: 'seats',
      className: 'is-width-10',
      render: (el) => el.seats.total,
      title: 'Total seats',
    },
    {
      key: 'closeDate',
      className: 'is-width-5',
      render: (el) =>
        el.closeDate ? formatDateToLocaleString(el.closeDate) : '',
      title: 'Close date',
      sortable: false,
    },
    {
      key: 'user',
      className: 'is-width-20',
      dataIndex: 'endUser',
      title: 'End user',
      sortable: false,
    },
    {
      key: 'hardware',
      className: 'is-width-5',
      render: (el) => (el.devices.total > 0 ? 'Yes' : 'No'),
      title: 'Hardware',
      sortable: false,
    },
    {
      key: 'assignedDevices',
      className: 'is-width-10',
      render: (el) => {
        return el.devices.total > 0
          ? `${el.devices.assigned}/${el.devices.total}`
          : 'N/A';
      },
      title: 'Assigned devices',
      sortable: false,
    },
  ];
};

const salesOrderOverviewColumns: Column<SalesOrdersTableRow>[] = [
  {
    key: 'number',
    className: 'is-width-10',
    render: (el) => (
      <Link to={`/sales-orders/${el.id}`}>
        {formatSalesOrderNumber(el.number)}
      </Link>
    ),
    title: 'Sales Order',
    sortable: true,
  },
  {
    key: 'opportunity.account.name',
    className: 'is-width-20',
    render: (el) => (
      <Link to={`/accounts/${el.opportunity?.account?.id}`}>
        {el.opportunity?.account?.name}
      </Link>
    ),
    title: 'Account',
    sortable: true,
  },
  {
    key: 'opportunity.name',
    className: 'is-width-20',
    render: (el) => el.opportunity?.name,
    title: 'Opportunity Name',
    sortable: true,
  },
  {
    key: 'seats',
    className: 'is-width-10',
    render: (el) => el.seats.total,
    title: 'Total seats',
  },
  {
    key: 'closeDate',
    className: 'is-width-5',
    render: (el) =>
      el.closeDate ? formatDateToLocaleString(el.closeDate) : '',
    title: 'Close date',
    sortable: false,
  },
  {
    key: 'user',
    className: 'is-width-20',
    dataIndex: 'endUser',
    title: 'End user',
    sortable: false,
  },
  {
    key: 'hardware',
    className: 'is-width-5',
    render: (el) => (el.devices.total > 0 ? 'Yes' : 'No'),
    title: 'Hardware',
    sortable: false,
  },
  {
    key: 'assignedDevices',
    className: 'is-width-10',
    render: (el) => {
      return el.devices.total > 0
        ? `${el.devices.assigned}/${el.devices.total}`
        : 'N/A';
    },
    title: 'Assigned devices',
    sortable: false,
  },
];

const salesOrderDetailsColumns: Column<SalesOrdersTableRow>[] = [
  {
    key: 'number',
    className: 'is-width-20',
    render: (el) => (
      <Link to={`/sales-orders/${el.id}`}>
        {formatSalesOrderNumber(el.number)}
      </Link>
    ),
    title: 'Sales Order',
    sortable: true,
  },
  {
    key: 'seats',
    className: 'is-width-15',
    render: (el) => el.seats.total,
    title: 'Total seats',
  },
  {
    key: 'closeDate',
    className: 'is-width-10',
    render: (el) =>
      el.closeDate ? formatDateToLocaleString(el.closeDate) : '',
    title: 'Close date',
    sortable: false,
  },
  {
    key: 'user',
    className: 'is-width-35',
    dataIndex: 'endUser',
    title: 'End user',
    sortable: false,
  },
  {
    key: 'hardware',
    className: 'is-width-20',
    render: (el) => el.devices.total,
    title: 'Hardware',
    sortable: false,
  },
];

export {
  resolveSalesOrderSummaryColumns,
  salesOrderDetailsColumns,
  salesOrderOverviewColumns,
};
